"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _excluded = ["error", "disabled", "required", "children"];

/**
 * Provides context to a control.
 */
var FormControl = function FormControl(_ref) {
  var error = _ref.error,
      disabled = _ref.disabled,
      required = _ref.required,
      children = _ref.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_core.FormControl, (0, _extends2["default"])({
    fullWidth: true,
    error: error,
    disabled: disabled,
    required: required
  }, rest), children);
};

FormControl.propTypes = {
  /** If `error={true}`, the component will be in an error state. */
  error: _propTypes["default"].bool,

  /** If `disabled={true}`, the component will be in a disabled state. */
  disabled: _propTypes["default"].bool,

  /** If `required={true}`, the component will be displayed as required. */
  required: _propTypes["default"].bool,

  /** The content of the component. */
  children: _propTypes["default"].node.isRequired
};
FormControl.defaultProps = {
  error: false,
  disabled: false,
  required: false
};
var _default = FormControl;
exports["default"] = _default;